import { render, staticRenderFns } from "./episode-detail.vue?vue&type=template&id=2ac4f247&scoped=true&lang=html&"
import script from "./episode-detail.vue?vue&type=script&lang=js&"
export * from "./episode-detail.vue?vue&type=script&lang=js&"
import style0 from "./episode-detail.vue?vue&type=style&index=0&id=2ac4f247&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4f247",
  null
  
)

export default component.exports